import { createContext } from 'react';

const AuthContext = createContext<any>(undefined);

export default AuthContext;
